import actions from "@/store/modules/news/actions";
import mutations from "@/store/modules/news/mutations";
import state from "@/store/modules/news/state";

export default {
    actions,
    mutations,
    state
}